import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import Calendar from "../../../components/calendar";
import { modifyApplicant, createApplicant } from "../../../api/api-applicant";
import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import { sharedNextPage } from "../../../utils/shared-functions";
import moment from "moment";

import { bindSharedToast, unbindSharedToast, sharedShowToast } from "../../../utils/shared-toast";

export default function ApplicantPage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");
  // const [listaCategoria, setListaCategoria] = useState([]);
  // const [categoriaSelected, setCategoriaSelected] = useState(null);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning");

  useEffect(() => {
    bindSharedToast({
      setMessage: setToastMessage,
      setType: setToastType,
      setVisible: setToastVisible,
    });
    return () => unbindSharedToast();
  }, []);

  useEffect(() => {
    // console.log("entro a Correos");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data === undefined || data === null) {
        sharedNextPage("list-applicant", {}, history);
        return;
      }
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
      }
      // const categorias = await obtenerListaCategoria({ habilitado: 1 }, true);
      // setListaCategoria(categorias);
      // if (data.params.idCategoria !== undefined && data.params.idCategoria !== null) {
      //   const categoria = categorias.find((item) => item.value === data.params.idCategoria);
      //   setCategoriaSelected(categoria);
      // }
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const charLimits = {
    code: 36,
    name: 512,
    phoneNumber: 256,
    emailAddress: 256,
    dateStart: 10,
    expectation: 1024,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (value.length <= charLimits[name]) {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      if (String(formData.descripcion).trim().length === 0) {
        message = message + t("alert_debe_ingresar_descripcion") + '\n';
      }
      if (message.length > 0) {
        alert(message);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarFormulario err');
      console.log(err);
      return false;
    }
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    const valido = validarFormulario();
    if (valido === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    objEnviar.code = formData.code;
    objEnviar.name = formData.name;
    objEnviar.phoneNumber = formData.phoneNumber;
    objEnviar.emailAddress = formData.emailAddress;
    objEnviar.dateStart = moment(formData.dateStart).format("YYYY-MM-DD");
    objEnviar.expectation = formData.expectation;
    setProcessingVisible(true);
    if (formData.id === 0) {
      // console.log('crear correo');
      const response = await createApplicant(objEnviar);
      setProcessingVisible(false);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        sharedShowToast(t("te_register_success"), "success", 3000, () => {
          handleCancelClick();
        });
      }
      if (response.error === true) {
        sharedShowToast(
          response.message || t("te_register_failed"),
          "error"
        );
      }
    }
    if (formData.id !== 0) {
      // console.log('actualizar correo');
      const response = await modifyApplicant(objEnviar);
      setProcessingVisible(false);
      // console.log('modificado');
      // console.log(modificado);
      if (response.error === false) {
        sharedShowToast(t("alert_proccesed_successfully"), "success", 3000, () => {
          handleCancelClick();
        });
      }
      if (response.error === true) {
        sharedShowToast(
          response.message || t("alert_process_failed"),
          "error"
        );
      }
    }
  };

  const render = () => {
    // console.log('render correo');
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      return (
        <div className="max-w-7xl mx-auto  bg-gray-100">
          <br />
          <div className="bg-white shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
            </div>
            {/* <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="categoria">
                  {t("label_categoria")}
                </label>
                <Select options={listaCategoria}
                  isSearchable='true'
                  isClearable='true'
                  value={categoriaSelected}
                  onChange={(event) => setCategoriaSelected(event)}
                  placeholder={t("placeholder_seleccione_categoria")}
                />
              </div>
            </div>
            <br /> */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="code"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_code")}
                </label>
                <input
                  id="code"
                  name="code"
                  type="text"
                  value={formData.code}
                  onChange={handleInputChange}
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.code}
                  placeholder={t("placeholder_input_code")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.code.length}/{charLimits.code}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="name"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_name")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  value={formData.name}
                  onChange={handleInputChange}
                  autoComplete="given-name"
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nombre}
                  placeholder={t("placeholder_input_name")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.name.length}/{charLimits.name}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="phoneNumber"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_phone_number")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="phoneNumber"
                  name="phoneNumber"
                  type="text"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                  autoComplete="given-name"
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.phoneNumber}
                  placeholder={t("placeholder_input_phone_number")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.phoneNumber.length}/{charLimits.phoneNumber}</p>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="emailAddress"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_email_address")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="emailAddress"
                  name="emailAddress"
                  type="text"
                  value={formData.emailAddress}
                  onChange={handleInputChange}
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.emailAddress}
                  placeholder={t("placeholder_input_email_address")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.emailAddress.length}/{charLimits.emailAddress}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="dateStart"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_date_start")}<span className="text-red-500">*</span>
                </label>
                <Calendar
                  id="dateStart"
                  name="dateStart"
                  value={formData.dateStart}
                  onChange={(v) => {
                    setFormData({
                      ...formData,
                      dateStart: v,
                    });
                  }}
                  format="MM-DD-YYYY"
                  required={true}
                  maxLength={charLimits.dateStart}
                />
                {/* <p className="text-sm text-gray-500 flex justify-end">{formData.dateStart.length}/{charLimits.dateStart}</p> */}
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="expectation"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_expectation")}<span className="text-red-500">*</span>
                </label>
                <textarea
                  id="expectation"
                  name="expectation"
                  type="text"
                  value={formData.expectation}
                  onChange={handleInputChange}
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.expectation}
                  placeholder={t("placeholder_input_expectation")}
                  rows={5}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.expectation?.length}/{charLimits.expectation}</p>
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_ACEPTAR}
                    onClick={handleSaveClick}
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
            <br />
          </div>
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
